<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#fibre2">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Fibre</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">4.2 g</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">0.6 g</span></div>

    </div>

    <div id="fibre2" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Galactooligozaharide (GOS)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.3 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.48 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fructooligozaharide (FOS)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.56 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.08 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3'Galactozillactoze (3'GL)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.10 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.015 g</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fibre",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
